<template>
  <div>
    <div class="container">
      <route-view></route-view>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import RouteView from './RouteView'
export default {
  name: 'DirectLayout',
  components: { RouteView },
  computed: {},
  data () {
    return {}
  },
  created() {
        const usertoken = this.$route.query.usertoken
        if(usertoken){
            Vue.ls.set(ACCESS_TOKEN, usertoken, 7 * 24 * 60 * 60 * 1000)
            this.$store.commit('SET_TOKEN', usertoken)
        }
        setTimeout(()=>{
          this.$connect()  //连接websocket
        },1000)
  },
  mounted () {},
  beforeDestroy () {}
  
}
</script>
<style lang="less" scoped>
</style>
